<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <div class="orangehrm-background-container orbit-modules-page">
    <h1 class="orbit-modules-title">Modules</h1>
    <p class="orbit-modules-text">
      Pick the module to work in; the side menu then shows its pages. You can
      switch at any time from the top of the side menu.
    </p>
    <orbit-module-cards action-label="Open" :current="current" @pick="open" />
  </div>
</template>

<script>
import OrbitModuleCards from '@/core/components/orbit/OrbitModuleCards.vue';
import {navigate} from '@ohrm/core/util/helper/navigation';

// Orbit HRM: the module picker inside the app (the side menu's switcher).
export default {
  name: 'OrbitModules',
  components: {
    'orbit-module-cards': OrbitModuleCards,
  },
  props: {
    current: {
      type: String,
      default: '',
    },
  },
  methods: {
    open(section) {
      navigate(`/dashboard/modules/${section}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.orbit-modules-page {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.orbit-modules-title {
  margin: 8px 0 4px;
  font-family: 'Sora', sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #12233f;
}
.orbit-modules-text {
  margin: 0 0 28px;
  font-size: 14px;
  color: #5b6779;
  text-align: center;
  max-width: 560px;
}
</style>
